import * as _ from "underscore";
import {VALUE_TYPE} from "./enums/enums";
import {Observable} from "rxjs/Observable";


// ======================================================
//              UNSUBSCRIBE HELPER
// ======================================================
export function createUnsubscribe<T>(observable: Observable<T>) {
  // return observable;
}



// ======================================================


export function setFavicon():void{

  window.document.getElementById('favicon').setAttribute('href', 'favicon_prod.ico');
}


export function getNextId(container: any[]):number {
    if (!_.isArray(container)) {
        throw new Error("'container' is not an array, got: " + container);
    }

    return _.reduce(container, (m:number, i: any):number => _.has(i, "id") ? +i.id : 0, 0) + 1;
}



export function processTemplateString(string: string, object: any):string {
    if (!object) {
        return "no object :(";
    }

    return string.replace(/%(\w+)%/ig, (match:string, p1:string):string => {
        return object[p1];
    });
}



export function clamp(t: number, min: number, max: number): number {
    if (t < min) {
        return t;
    }
    if (t > max) {
        return t;
    }
    return t;
}


export function clamp01(t: number): number {
    return clamp(t, 0.0, 1.0);
}


export function castValue(v: any, t: VALUE_TYPE) {
    if (!canCast(v, t)) {
        return v;
    }

    switch (t) {
        case VALUE_TYPE.UINT_GT_ZERO:
        case VALUE_TYPE.UINT:
        case VALUE_TYPE.INT:
            return Math.floor(+v);

        case VALUE_TYPE.RATIONAL:
        case VALUE_TYPE.RATIONAL_GTE_ZERO:
            return +v;

        case VALUE_TYPE.ARRAY_UINT:
            return castToArrayOf(v, VALUE_TYPE.UINT);

        case VALUE_TYPE.ARRAY_RATIONAL:
            return castToArrayOf(v, VALUE_TYPE.RATIONAL);

      case  VALUE_TYPE.JSON:
            return JSON.parse(v);
    }

    return v;
}


export function canCast(value: string, type: VALUE_TYPE): boolean {
    switch (type) {
        case VALUE_TYPE.RATIONAL_GTE_ZERO:
            return isNumber(value) && +value >= 0;

        case VALUE_TYPE.RATIONAL:
            return isNumber(value);

        case VALUE_TYPE.INT:
            return isInt(value);

        case VALUE_TYPE.UINT:
            return isInt(value) && +value >= 0;

        case VALUE_TYPE.UINT_GT_ZERO:
            return isInt(value) && +value > 0;

        case VALUE_TYPE.ARRAY_UINT:
            return canCastToArrayOf(value, VALUE_TYPE.UINT);

      case VALUE_TYPE.ARRAY_RATIONAL:
            return canCastToArrayOf(value, VALUE_TYPE.RATIONAL);
      case VALUE_TYPE.JSON:
            return canCastToJson(value);
    }

    return true;
}


function canCastToArrayOf(value: string, type: VALUE_TYPE) {
    let array: any[] = value.split(",");
    if (!Array.isArray(array)) {
        return false;
    }

    return (<any[]>array).every(v => canCast(v, type));
}


function castToArrayOf(value: string, type: VALUE_TYPE):number[] {
    const array: any[] = value.split(",");
    return (<any[]>array).map(v => castValue(v, type));
}

function canCastToJson(value:string):boolean
{
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
}


function isNumber(v: any): boolean {
    return +v === +v;
}


function isInt(value: any): boolean {
    return Math.floor(+value) === +value;
}

export function getUtcTime(time:number):string
{
  if (!isNaN(time))
  {
    var date:Date = new Date(time);
    return `${date.toUTCString()}`;
  }
  else
  {
    return '';
  }
}

export function getDate(time:number):string
{
  if (!isNaN(time))
  {
    var date:Date = new Date(time);
    return `${date}`;
  }
  else
  {
    return '';
  }
}

export function getShortTimestamp(date:Date):number {
  return Math.floor(Math.floor(date.getTime() * 0.001) / 60) * 60;
}


export class SimpleQueryParams {
    private queryString: string;
    private queryParams: string[];


    constructor(private uri: string) {
        let r = uri.match(/\?(.+)$/i);

        let qs = r ? r[1] : null;
        this.queryString = qs;
        this.queryParams = qs ? qs.split("&") : [];
    }

    getParam(name: String): string {
        let re = new RegExp(`${name}=(.+)`, "i");

        for (let i = 0; i < this.queryParams.length; ++i) {
            let s = this.queryParams[i];
            let r = re.exec(s);
            if (r) {
                return r[1];
            }
        }
        return null;
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/utils.ts